(ns ui.components.notification.view
  (:require
   [re-frame.core :as rf]
   [ui.components.radix-ui.index :as radix]
   [ui.fx.timeout :as timeout]
   [ui.util :as uu]))

(def ^:private auto-close-timeout-id ::auto-close-notification)
(def ^:private auto-close-wait-ms 4000)

(defn auto-close-notification?
  [type requested?]
  (and requested?
       (not= :error type)))

(defn open-notification-effects
  [db {:keys [title desc type auto-close?]}]
  (let [auto-close? (auto-close-notification? type auto-close?)]
    {:db (assoc db
                :notification
                {:open?       true
                 :title       title
                 :desc        desc
                 :type        type
                 :auto-close? auto-close?})
     ::timeout/timeout
     {:id      auto-close-timeout-id
      :event   (when auto-close?
                 [:close-notification])
      :wait-ms auto-close-wait-ms}}))

(rf/reg-event-fx
 :open-notification
 (fn [{:keys [db]} [_ notification]]
   (open-notification-effects db notification)))

(rf/reg-event-db
 :close-notification
 (fn [db _]
   (assoc-in db [:notification :open?] false)))

(rf/reg-sub
 :notification
 :notification)

(defn info-icon
  [type]
  (case type
    :success [:i.fa.fa-check-circle
              {:class "text-2xl text-success-light-text"}]
    :error [:i.fa.fa-exclamation-circle
            {:class "text-2xl text-danger-light-text"}]
    [:i.fal.fa-info-circle
     {:class "text-2xl text-info-light-text"}]))

(defn view
  []
  (let [{:keys [open? title desc type]} @(rf/subscribe [:notification])]
    [radix/portal
     [:div
      {:class (uu/cm
               "fixed inset-x-0 top-5 z-[40000001] px-4 pointer-events-none transition-all duration-300"
               (if open?
                 "visible opacity-100 translate-y-0"
                 "invisible opacity-0 -translate-y-full"))}
      [:div
       {:class "p-3 mx-auto max-w-96 w-full min-h-16 max-h-[calc(100dvh-2.5rem)] overflow-y-auto pointer-events-auto flex gap-3 items-start justify-between text-base-regular-text bg-base-regular shadow-md rounded"}
       [:div {:class "flex min-w-0 items-start gap-3"}
        [info-icon type]
        [:div {:class "min-w-0 flex flex-col gap-2 break-words"}
         [:p {:class "m-0 font-bold break-words"} title]
         [:p
          {:class "m-0 text-sm break-words"}
          desc]]]
       [:button
        {:class    "shrink-0"
         :on-click (fn [_]
                     (rf/dispatch [:close-notification]))}
        [:i.fa.fa-times
         {:class "font-normal text-base-regular-text hover:text-base-regular-text-accent"}]]]]]))
